import { Component, OnInit } from '@angular/core'
import { FieldArrayType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-repeat',
  templateUrl: './formly-repeat.component.html',
  styleUrls: ['./formly-repeat.component.scss'],
})
export class FormlyRepeatComponent extends FieldArrayType implements OnInit {
  constructor() {
    super()
  }

  ngOnInit(): void {
    this.props.add = this.add.bind(this)
    this.props.remove = this.remove.bind(this)
  }
}
